<template v-if="Object.keys(fields).length !== 0">
  <div class="widget widget-checkbox-group" :data-field="fieldName">
    <inline-help-modal ref="inlineHelpModal"></inline-help-modal>
    <hr>
    <label v-for="(data, index) in fields" :key="index" v-if="data !== null">
      {{ data.translations.en.label }}
      <h6>{{ data.translations.en.text }}</h6>
      <br>
      <template v-if="data.type === 'checkbox'" >
        <p>
          <input type="checkbox" :data-key="index" :ref="index" :key="index" @click="highLightCheckbox({name:index, type: data.type})" :value="index">
        </p>
      </template>
      <template v-if="data.type === 'text'">
        <input type="text" class="form-control form-control-sm" :data-key="index" :ref="index" :key="index" @click="highLightCheckbox({name:index, type: data.type})" :value="index">
      </template>
      <template v-if="data.type === 'select'">
        <select :data-key="index" class="form-control form-control-sm" :ref="index" :key="index" @click="highLightCheckbox({name:index, type: data.type})" :value="index">
          <option>'ComboBox'</option>
        </select>
      </template>
      <div class="widget-sort">
        <i class="fas fa-angle-double-up" @click="move(index, true)"></i>
        <i class="fas fa-angle-double-down" @click="move(index, false)"></i>
      </div>
      <button class="classic btn btn-light" @click="showQuestionHelp(data.name, data.translations.en.text)">Parse Inline Help</button>
      <button class="classic btn btn-light" @click="restoreInlineHelp(data.name)">Restore Inline Help</button>
      <hr>
    </label>
    <br>
  </div>

</template>

<script>

import InlineHelpModal from '@/components/questionnaires/InlineHelpModal'

export default {
  name: 'field-group-widget',

  components: {
    InlineHelpModal
  },

  mounted () {
    let that = this
    this.setTypeFields()

    this.$bus.on('moveFieldGroupField', function (dataMove) {
      that.move(dataMove.moveIndex, dataMove.up)
    })
  },

  props: {
    fieldIndex: {
      type: String,
      required: true
    },
    checkboxes: {
      type: Object,
      required: true
    },
    maxChecked: {
      type: Number,
      default: 1
    },
    initialValue: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    model: {
      type: String,
      default: ''
    },
    fieldName: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      checkedBoxes: [],
      fields: {}
    }
  },

  methods: {
    restoreInlineHelp (fieldName) {
      let that = this
      window.swal({
        title: 'Restore Inline Help?',
        text: 'You are about to restore this field inline help. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((restore) => {
        if (restore) {
          let dataInlineHelp = this.$store.getters.getInlineHelpFromTemplate(fieldName)
          if (dataInlineHelp === null) return
          else {
            this.$store.commit('changeInlineHelp', {
              questionnaireId: that.fieldIndex,
              name: fieldName,
              label: dataInlineHelp.label,
              inlineHelp: dataInlineHelp.text
            })
            this.$store.commit('saveInlineHelpDb')
            // this.$bus.emit('setQuestionnairesFields')
            this.$store.dispatch('saveTemplate')
            this.$bus.emit('updateQuestionnaire')
          }
        }
      })
    },

    showQuestionHelp (fieldName, desc) {
      let that = this
      this.$refs.inlineHelpModal.$emit('showInlineHelp')
      this.$bus.emit('sendInlineHelp', {
        questionnaireId: that.fieldIndex,
        text: desc,
        name: fieldName,
        one: true
      })
    },

    move (moveIndex, up) {
      let fieldKeys = Object.keys(this.fields)

      let tmpFields = JSON.parse(JSON.stringify(this.fields))

      fieldKeys.forEach((key, index) => {
        if (key === moveIndex) {
          let tmpTabOrder = tmpFields[moveIndex].tabOrder
          let indexChange = index

          if (up === true && index > 0) indexChange--
          else indexChange++

          tmpFields[moveIndex].tabOrder = tmpFields[fieldKeys[indexChange]].tabOrder

          tmpFields[fieldKeys[indexChange]].tabOrder = tmpTabOrder
        }
      })

      this.fields = this.setOrderFields(tmpFields)

      this.$store.commit('setFieldGroupFields', {
        nameGroup: this.fieldName,
        fields: this.fields
      })
      this.$store.dispatch('saveTemplate')
    },

    setOrderFields (objFields) {
      let orderFields = []

      orderFields = Object.values(objFields)

      orderFields = orderFields.sort((a, b) => (a.tabOrder > b.tabOrder) ? 1 : -1)

      let tmpFields = {}

      orderFields.forEach(field => {
        tmpFields[field.id] = field
      })

      return tmpFields
    },

    setTypeFields () {
      let that = this
      let newFields = {}
      Object.keys(this.checkboxes).forEach(fieldId => {
        let dataField = this.$store.getters.getTemplateData(fieldId)
        if (dataField === null) return
        if (this.checkboxes[fieldId].translations === undefined) {
          that.checkboxes[fieldId].translations = dataField.translations
          this.$store.commit('setFieldGroupFields', {
            nameGroup: that.fieldName,
            fields: that.checkboxes
          })
          this.$store.dispatch('saveTemplate')
          this.$bus.emit('updateQuestionnaire')
        }
        newFields[fieldId] = that.checkboxes[fieldId]
      })
      this.fields = this.setOrderFields(newFields)
    },

    highLightCheckbox (dataField) {
      this.$bus.emit('setFieldPage', dataField)
    },

    getCheck: function (index) {
      return this.checkedBoxes[index]
    },

    onChange (e) {
      const checked = this.$el.querySelectorAll(':checked')
      const checkKey = e.target.value
      if (this.checkedBoxes.indexOf(checkKey) !== -1) {
        this.checkedBoxes.splice(this.checkedBoxes.indexOf(checkKey))
      } else if (checked.length <= this.maxChecked) {
        this.checkedBoxes.push(checkKey)
      }

      for (const checkbox of this.$el.querySelectorAll('input[type=checkbox]')) {
        checkbox.checked = this.checkedBoxes.indexOf(checkbox.getAttribute('data-key')) !== -1
      }

      this.$parent.$emit('widgetChanged', {index: this.fieldIndex, value: JSON.stringify(this.checkedBoxes)})
    }
  },

  beforeDestroy () {
    this.$bus.$off('moveFieldGroupField')
  }
}
</script>

<style lang="scss" scoped>
  .readOnly {
    pointer-events: none;
  }

  input[type=checkbox] {
    margin-right: 5px;
  }

  label {
    // margin-right: 10px;
    font-weight: normal;
    display: block;
  }

  .auto-width {
    margin: 0 auto;
    display: table;
  }

  .widget-sort {
    position: absolute;
    margin-top: -67px;
    right: 23px;
    font-size: 14px;
    // margin-left: 540px;
    i {
      display: inline;
      font-size: 1.5em;
      font-weight: bold;
      margin-left: 10px;
      cursor: pointer;

      &:hover {
        color: #2D5F8B;
      }
    }
  }

  button.classic {
    margin-top: 8px;
    background-color: white;
    border: 1px solid lightgray;
  }
  button.classic:hover {
    background-color: rgb(199, 199, 199);
  }

  hr {
    border-top: 1px solid rgb(193, 193, 193);
  }
</style>



// WEBPACK FOOTER //
// src/components/questionnaires/widgets/FieldGroupWidget.vue